import { render, staticRenderFns } from "./MyProfileAddressLookup.vue?vue&type=template&id=c480e2f4"
import script from "./MyProfileAddressLookup.vue?vue&type=script&lang=js"
export * from "./MyProfileAddressLookup.vue?vue&type=script&lang=js"
import style0 from "./MyProfileAddressLookup.vue?vue&type=style&index=0&id=c480e2f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports